function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { Controller } from "react-hook-form";
import TimeInput from "../../components/Timeinput/TimeInput";
const TimeField = ({
  isError,
  useFormProps,
  field,
  wuiltContext
}) => {
  return /*#__PURE__*/React.createElement(Controller, {
    control: useFormProps?.control,
    name: field?.id
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ,
    render: ({
      field: {
        ref,
        ...fieldProps
      }
    }) => /*#__PURE__*/React.createElement(TimeInput, _extends({
      isError: isError
    }, fieldProps, {
      wuiltContext: wuiltContext
    }))
  });
};
export default TimeField;
//# sourceMappingURL=TimeField.js.map